import React, {useRef, useState, useEffect, useMemo} from "react";
import {Button} from "../components";
import {useMedia} from "../hooks/useMedia";
import {cn, getRandomEmoji, spring} from "../lib/utils";
import {AnimatePresence, motion} from "framer-motion";
import {Trans, useTranslation} from "react-i18next";

const Banner = ({
  onClick,
  pause,
  demovideoUrl,
}: {
  onClick: any;
  pause: any;
  demovideoUrl: string;
}) => {
  const {t} = useTranslation();

  const ref = useRef<HTMLVideoElement>(null);
  const [showEmoji, setShowEmoji] = useState(false);
  const isMobile = useMedia("(max-width: 768px)", false);

  useEffect(() => {
    if (!ref.current) return;
    if (pause) ref.current?.pause();
    else ref.current?.play().catch(console.warn);
  }, [pause]);

  return useMemo(
    () => (
      <div className="relative max-md:mx-2 w-[calc(100vw_-_16px)] md:w-full rounded-3xl aspect-[5/6] bg-black">
        <video
          ref={ref}
          className="absolute left-0 top-0 w-full max-w-full h-full object-cover rounded-3xl opacity-90"
          src={"/" + demovideoUrl}
          playsInline
          autoPlay
          muted
          loop
        />
        <div className="absolute inset-0 flex flex-col justify-between p-2">
          <div className="p-4 text-white flex flex-col gap-4">
            <h1 className="text-white text-6xl md:text-7xl z-10">
              <Trans i18nKey="recipe_details.upselling.title" components={{br: <br />}}/>
            </h1>
            <p className="text-xl [text-wrap:balance] max-w-xs">
              {t("recipe_details.upselling.subtitle")}
            </p>
          </div>
          <AnimatePresence>
            {showEmoji && (
              <>
                {Array.from({length: 2}).map((_, i) => (
                  <motion.div
                    key={i}
                    className={cn(
                      "absolute text-7xl pointer-events-none",
                      i ? "right-4 bottom-0" : "left-5 bottom-0"
                    )}
                    transition={{...spring.bouncy, delay: i * 0.075}}
                    initial={{scale: 0.5, opacity: 0, rotate: 20}}
                    animate={{
                      scale: 1,
                      opacity: 1,
                      y: i ? -20 : 10,
                      x: i ? 40 : -40,
                      rotate: -20,
                    }}
                    exit={{
                      scale: 0.5,
                      opacity: 0,
                      transition: {duration: 0.1},
                    }}
                  >
                    {getRandomEmoji()}
                  </motion.div>
                ))}
              </>
            )}
          </AnimatePresence>
          <Button
            variant="secondary"
            onClick={onClick}
            onMouseEnter={() => isMobile && setShowEmoji(true)}
            onMouseLeave={() => setShowEmoji(false)}
          >
            {t("recipe_details.upselling.cta")}
          </Button>
        </div>
      </div>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showEmoji]
  );
};

export {Banner};
